import L from 'leaflet';
import Popup from '../popup/popup';

export default class Polygon extends L.Polygon {
    constructor(map, data, fnSelectZone) {
        super(data.dataForMap.points, {
            fill: true,
            fillColor: data.dataForMap.color,
            color: data.dataForMap.color,
            weight: 3,
        });
        this.map = map;
        this.points = data.dataForMap.points;
        this.type = data.type;
        this.color = data.dataForMap.color;
        this.icon = data.dataForMap.icon;
        this.name = data.name;
        this.id = data.id;
        this.data = data;
        this.fnSelectZone = fnSelectZone;
        this.tooltip;
        this.permanentTooltipOpened = false;
        document.addEventListener('map:toggleGeofenceTooltipVisibility', e => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });

        this.addTooltip({ permanent: false });

        this.on('click', this.onClick);
        this.on('mouseover', this.onOver);
        this.on('mouseout', this.onOut);

        this.map.on('zoomend', (e) => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });

        this.map.on('moveend', (e) => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });

        this.toggleTooltipVisibility();
    }

    getCoords() {
        let latLngs = this.getLatLngs()[0].map(item => {
            return {
                lat: item.lat,
                lon: item.lng
            };
        });
        return latLngs;
    }

    onOver() {
        if (!this.permanentTooltipOpened) {
            this.openTooltip();
        }
    }

    onOut() {
        if (!this.permanentTooltipOpened) {
            this.closeTooltip();
        }
    }

    onClick(e) {
        if (this.map.isAllClicksBlocked()) {
            return;
        }
        this.fnSelectZone(this.id)
            .then(data => {
                this.popup = new Popup(this.map, this.name, data.params, e.latlng);
                this.popup.show();
            });
    }

    toggleTooltipVisibility() {
        const options = this.map.options.geofenceTooltip;
        try {
            if (
                options.isAlwaysVisible
                && !this.permanentTooltipOpened
                && this.map.getZoom() >= options.minVisibleZoom
                && this.map.getBounds().contains(this.getBounds().getCenter())
            ) {
                this.permanentTooltipOpened = true;
                this.addTooltip({ permanent: true });
                this.openTooltip(this, this.getBounds().getCenter());
            }
            else if (
                this.permanentTooltipOpened && !options.isAlwaysVisible
                || this.permanentTooltipOpened && this.map.getZoom() < options.minVisibleZoom
            ) {
                this.permanentTooltipOpened = false;
                this.addTooltip({ permanent: false });
            }
        }
        catch (error) {
            console.error('polygone', this.id, error);
        }
    }

    addTooltip(options) {
        if (this.tooltip) {
            this.unbindTooltip(this.tooltip);
        }
        this.tooltip = L.tooltip({
            permanent: options.permanent,
            interactive: false,
            direction: 'bottom',
            offset: new L.Point(0, 0)
        });
        this.tooltip.setContent(this.name);
        this.tooltip.on('click', (e) => { this._onClick(e) });
        this.bindTooltip(this.tooltip);
    }
}
